export default __webpack_public_path__ + "static/productsLogo-3d51e7e8fae6c55dd38067533f94001e.svg";